const component = "section-children-programming-ranges-count-cell";

export const sectionChildrenProgrammingRangesCountCell = {
  component,
  countLeafDescendantsProgrammingRangesText: `${component}/count-leaf-descendants-programming-ranges-text`,
};
